import {TranslateService} from '@ngx-translate/core';
import {CommonUtils} from '../utils/common';
import {FormGroup} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {ViewChild} from '@angular/core';
import {IonContent, ModalController} from '@ionic/angular';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export class TranslatedPage {
  public static translationInInitialized = false;

  @ViewChild(IonContent, { static: false }) content: IonContent;

  public backBtnCommands: any[];

  public language: string;
  protected isBusy = false;
  protected isOffline = false;

  protected hasUnsavedChanges = false;

  constructor(
    private translateService: TranslateService,
    public commonUtilsLib: CommonUtils,
    private initializeTranslation = true
  ) {
    this.initializeTranslation = initializeTranslation;
  }

  isFormFieldInvalid(form: FormGroup, fieldName: string, validationType: string) {
    return this.commonUtilsLib.isFormFieldInvalid(form, fieldName, validationType);
  }

  isFormInvalid(form: FormGroup, validationType: string) {
    return this.commonUtilsLib.isFormInvalid(form, validationType);
  }

  ionViewDidEnter(): void {
    this._initTranslate();
  }

  _translateLanguage(): void {
    this.translateService.use(this.language);
  }

  _forceInitTranslate() {
    this.initializeTranslation = true;
    this._initTranslate();
    TranslatedPage.translationInInitialized = true;
  }

  translationExist(key: string): boolean {
    return this.translateService.instant(key) !== key;
  }

  _initTranslate() {
    if (this.initializeTranslation && !TranslatedPage.translationInInitialized) {
      // Set the default language for translation strings, and the current language.
      this.translateService.setDefaultLang('pl');
      this.language = 'pl';

      /*
            if (this.translateService.getBrowserLang() !== undefined && this.language !== this.translateService.getBrowserLang()) {
              this.translateService.setDefaultLang('en');
              this.language = 'en';
            } else {
              this.language = 'pl';
            }
      */

      this._translateLanguage();
    }
  }

  scrollToLabel(label) {
    const titleELe = document.getElementById(label);
    this.content.scrollToPoint(0, titleELe.offsetTop, 1000);
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChanges = true;
      console.log('was changed');
    }
  }
}
